// The video recordings the platform analyses (PRD-0074), by extension. One list with the
// server's `spectre.core.video`: the row offers "Analyse video" for exactly these, and WebM
// stays an audio format (`audio-playback.ts`).
export const VIDEO_FILE_TYPES = [
  'mp4',
  'mov',
  'm4v',
  'mkv',
  'avi',
  'wmv',
  'flv',
  'mts',
  'ts',
] as const

const VIDEO_FILE_TYPE_SET: ReadonlySet<string> = new Set(VIDEO_FILE_TYPES)

/** Temporary release gate, matching spectre.core.video, until the engine is ready. */
export const VIDEO_PROCESSING_AVAILABLE = false

export function isVideoUnavailable(fileType: string | null | undefined): boolean {
  return !VIDEO_PROCESSING_AVAILABLE && isVideoFileType(fileType)
}

export function isVideoUploadUnavailable(file: Pick<File, 'name' | 'type'>): boolean {
  return (
    !VIDEO_PROCESSING_AVAILABLE &&
    (isVideoFileType(file.name.split('.').pop()) || file.type.toLowerCase().startsWith('video/'))
  )
}

/** The same as the suffixes a file picker is given: `.mp4`, `.mov`, … */
export const VIDEO_FILE_SUFFIXES: readonly string[] = VIDEO_FILE_TYPES.map(type => `.${type}`)

/** A recording may be up to 8 GB and an hour (PRD-0074 SC-001); any other upload 100 MB. */
export const MAX_VIDEO_UPLOAD_BYTES = 8 * 1024 * 1024 * 1024

/** Whether a document's `file_type` (its extension) is a video the platform analyses. */
export function isVideoFileType(fileType: string | null | undefined): boolean {
  return fileType ? VIDEO_FILE_TYPE_SET.has(fileType.toLowerCase()) : false
}

/** Seconds into a recording as `m:ss` (or `h:mm:ss` past an hour), the way a player shows them. */
export function formatVideoTime(seconds: number): string {
  const whole = Math.max(0, Math.floor(seconds))
  const hours = Math.floor(whole / 3600)
  const minutes = Math.floor((whole % 3600) / 60)
  const rest = whole % 60
  const mmss = `${hours ? String(minutes).padStart(2, '0') : minutes}:${String(rest).padStart(2, '0')}`
  return hours ? `${hours}:${mmss}` : mmss
}
